import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 10V5H4v5H2v7h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-7h-2zm-9 0H6V7h5v3zm7 0h-5V7h5v3z"
}), 'KingBedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KingBedSharp.js
// module id = 4368
// module chunks = 2